import React from 'react';
export function ProblemSection() {
  const problems = [{
    emoji: '😰',
    title: 'Creative Burnout',
    text: "You arrive at the studio exhausted after spending hours looking for new sequences on social media that you don't know how to connect."
  }, {
    emoji: '🍃',
    title: 'Lack of Structure',
    text: "Your classes lose their flow. You improvise transitions and fear your students aren't progressing logically."
  }, {
    emoji: '📱',
    title: 'Information Overload',
    text: "You search Google and find contradictory exercises. You don't know what structure is most effective for a 55-minute session."
  }, {
    emoji: '😩',
    title: 'Massive Mental Load',
    text: 'Managing students and planning stops you from enjoying your true passion for Pilates.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-174">
            DO YOU RECALL THIS?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-5 tracking-tight" data-id="element-175">
            You love teaching, but does{' '}
            <span className="italic text-pilates-rose" data-id="element-176">preparation</span> steal
            all your free time?
          </h2>
          <p className="text-lg text-pilates-slate max-w-2xl mx-auto" data-id="element-177">
            If you are a Pilates instructor, you probably know one of these
            situations:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-178">
          {problems.map((p, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/20 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-179">
              <div className="text-4xl mb-3" data-id="element-180">{p.emoji}</div>
              <h3 className="font-display text-xl font-semibold text-pilates-dark mb-2" data-id="element-181">
                {p.title}
              </h3>
              <p className="text-pilates-slate leading-relaxed" data-id="element-182">{p.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}